import { atom, useSetAtom, useAtomValue } from 'jotai';

export interface LocalSearchMsg {
  sendTime: string;
  msgId: string;
}
/** 本地搜索点击搜出来的聊天记录时,记录该记录的`sendTime` */
export const searchMsgSelectedSendTime = atom<LocalSearchMsg>({ sendTime: '', msgId: '' });

export const useSetSearchMsgSelectedSendTime = () => {
  return useSetAtom(searchMsgSelectedSendTime);
};

export const useSearchMsgSelectedSendTime = () => useAtomValue(searchMsgSelectedSendTime);
